import React, { useMemo } from 'react';
import { AppButton, Box, Responsive, Text, useResponsive } from '@common-fe/common-fe';

import { PaymentMethodLabel } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/PaymentMethodLabel';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { AllowedPaymentMethodConfig } from '@/modules/user/user.types';
import colors from '@/styles/colors';
import spacings from '@/styles/spacings';

interface Props {
  onAdd?: () => void;
  allowedPaymentMethodConfigs?: AllowedPaymentMethodConfig[];
  isRefund?: boolean;
}

const PaymentMethodField: React.FC<Props> = ({ onAdd, allowedPaymentMethodConfigs, isRefund }) => {
  const { isMobile } = useResponsive();
  const paymentMethod = useStore((state) => state.activeMethod);
  const title = useMemo(() => {
    const type = isRefund ? 'Refund Method' : 'Payment Method';
    return paymentMethod ? 'Change ' + type : 'Add ' + type;
  }, [isRefund, paymentMethod]);
  const paymentEmployeeFee = useMemo(
    () =>
      allowedPaymentMethodConfigs?.find((item) => item?.paymentMethodType === paymentMethod?.type)
        ?.paymentEmployeeFee,
    [allowedPaymentMethodConfigs, paymentMethod]
  );

  return (
    <Box style={{ position: 'relative' }} fill={isMobile}>
      <Box margin={{ bottom: spacings.s }}>
        <PaymentMethodLabel
          paymentMethod={paymentMethod}
          showPlaidStatus
          hasPaymentEmployeeFee={Boolean(allowedPaymentMethodConfigs?.length)}
          paymentEmployeeFee={paymentEmployeeFee}
        />
      </Box>

      {onAdd ? (
        <>
          <Responsive sizes={[Responsive.Desktop, Responsive.Tablet]}>
            <Box
              style={{
                position: 'absolute',
                top: '100%',
              }}
              width="max-content"
            >
              <Box onClick={onAdd} style={{ fontSize: '14px' }} width="fit-content">
                <Text color={colors.textAccent} weight={500} style={{ whiteSpace: 'nowrap' }}>
                  {title}
                </Text>
              </Box>
            </Box>
          </Responsive>
          <Responsive sizes={[Responsive.Mobile]}>
            <Box fill width="max-content">
              <AppButton fill buttonType="secondary" onClick={onAdd}>
                {title}
              </AppButton>
            </Box>
          </Responsive>
        </>
      ) : null}
    </Box>
  );
};
export default PaymentMethodField;
